import { Box, Stack } from '@mantine/core';
import { FeedbackForm } from 'components/FeedbackForm';
import { i18nKeys, useTranslation } from 'locales';

import { AnalyticsCard } from '../AnalyticsCard';

const LABELS = i18nKeys.ANALYTICS.MORE_CHARTS;

const BAR_WIDTH = 34;
const BAR_GAP = 14;
const BAR_HEIGHTS = [55, 81, 68, 107, 94, 132, 120, 158, 145];
const CHART_HEIGHT = 168;
const CHART_WIDTH = BAR_HEIGHTS.length * BAR_WIDTH + (BAR_HEIGHTS.length - 1) * BAR_GAP;

const PlaceholderChart = () => (
  <svg
    viewBox={`0 0 ${CHART_WIDTH} ${CHART_HEIGHT}`}
    aria-hidden="true"
    focusable="false"
    style={{ display: 'block', width: '100%', maxWidth: CHART_WIDTH, height: 'auto' }}
  >
    {BAR_HEIGHTS.map((height, index) => (
      <rect
        key={height}
        x={index * (BAR_WIDTH + BAR_GAP)}
        y={CHART_HEIGHT - height}
        width={BAR_WIDTH}
        height={height}
        rx={4}
        fill={index % 3 === 2 ? 'var(--mantine-color-purple-3)' : 'var(--mantine-color-purple-2)'}
      />
    ))}
  </svg>
);

export const MoreChartsCard = () => {
  const { t } = useTranslation();

  return (
    <AnalyticsCard title={t(LABELS.TITLE)} panelProps={{ fullHeight: true }}>
      <Stack gap="lg" mt="md" h="100%" justify="center">
        <Box
          bg="purple.0"
          p="md"
          style={{ borderRadius: 8, display: 'flex', justifyContent: 'center' }}
        >
          <PlaceholderChart />
        </Box>
        <FeedbackForm
          featureName="Analytics charts"
          label={t(LABELS.QUESTION)}
          isFillingHeight={false}
        />
      </Stack>
    </AnalyticsCard>
  );
};
